import React from 'react';
import dayjs from 'dayjs';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { css } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { OutlineButton } from '../../../../components/outlineButton';
import { useTranslation } from 'react-i18next';
import HeatmapModule from 'highcharts/modules/heatmap';

HeatmapModule(Highcharts);

interface Props {
  id: string;
  graphOption: Highcharts.Options;
  activityGraphOption?: Highcharts.Options;
  range: { start: dayjs.Dayjs; end: dayjs.Dayjs };
  isFirst: boolean;
  isResampleView: boolean;
  isActivityStatusView: boolean;
  onDelete: (id: string) => void;
}

const Container = css``;

const Header = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DetailGraphItem = React.memo(
  ({
    id,
    graphOption,
    activityGraphOption,
    range,
    isFirst = false,
    isResampleView,
    isActivityStatusView,
    onDelete,
  }: Props) => {
    const chartRef = React.useRef<HighchartsReact.RefObject>(null);
    const { start, end } = range;
    const { t } = useTranslation();

    const handleDelete = React.useCallback(() => {
      onDelete(id);
    }, []);

    React.useEffect(() => {
      if (!chartRef.current) return;
      chartRef.current.chart.redraw();
    }, [isResampleView, isActivityStatusView]);

    return (
      <div css={Container}>
        {!isFirst && (
          <div css={Header}>
            <div>
              {start.local().format('YYYY/MM/DD HH:mm:ss')} ~ {end.local().format('YYYY/MM/DD HH:mm:ss')}
            </div>
            <div>
              <OutlineButton icon={<CloseIcon />} onClick={handleDelete}>
                {t('removeGraph', 'グラフを非表示')}
              </OutlineButton>
            </div>
          </div>
        )}
        <HighchartsReact ref={chartRef} highcharts={Highcharts} options={graphOption} />
        {!!(activityGraphOption as any)?.series?.[0]?.data?.length && isActivityStatusView && (
          <HighchartsReact highcharts={Highcharts} options={activityGraphOption} />
        )}
      </div>
    );
  }
);
